import setShowFolderPane from './actions/setShowFolderPane';
import setFolderPaneWidth from './actions/setFolderPaneWidth';

import applyConversationFlaggedStateStitch from './stitches/applyConversationFlaggedStateStitch';
import updateItemMandatoryPropertiesStitch from './stitches/updateItemMandatoryPropertiesStitch';
import updateLoadedConversationStitch from './stitches/updateLoadedConversationStitch';
import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';

import './orchestrators/exitSearchOrchestrator';

export {
    getLeftNavWidth,
    getFolderListWidth,
    getSearchBoxLeftPadding,
    LEFT_RAIL_STATIC_WIDTH,
    MIN_NAVIGATION_BAR_WIDTH,
    MAX_NAVIGATION_BAR_WIDTH,
} from './actions/getLeftNavWidth';
export { setShowFolderPane, setFolderPaneWidth };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ToggleFolderPaneExpansion" */ './lazyIndex')
);

export let lazyToggleFolderPaneExpansion = new LazyAction(
    lazyModule,
    m => m.toggleFolderPaneExpansion
);

runAfterBootstrap(() => {
    applyConversationFlaggedStateStitch();
    updateItemMandatoryPropertiesStitch();
    updateLoadedConversationStitch();
});
